/**
 * Accessing values through the function prevents the compiler from optimizing them away as constants.
 */
function getEnvVariable(envName: string): string {
  if (import.meta.env.VITE_DOCKER_BUILDING_PROCESS === 'true') {
    // When Docker is building the function returns env key (placeholder).
    // Placeholders are replaced with actual values during Docker startup via `entrypoint.sh`.
    return envName
  }

  return import.meta.env[envName]
}

export const ENV_CONFIG = {
  ENGINE_URI: getEnvVariable('https://api.integration.test.m-files.com'),
  ENABLE_TRACKING: getEnvVariable('NEXT_PUBLIC_ENABLE_TRACKING'),
}
